import CompanyContactDetails from '../companyContact/companyContactDetails';
import CompanyImageActions from './companyImageActions';
import CompanyAddress from './companyAddress';
import { Box, Grid } from '@mui/material';
import '../../../css/companies/oneCompanyDetails/companyDetailsContent.css';

const CompanyDetailsContent = () => {
  return (
    <Grid container spacing={3} className='companyDetailsContent_main_grid'>
      {/* Left Column: Company Image */}
      <Grid item xs={12} md={4} padding={3}>
        <Box className='companyDetailsContent_image_chiffre_box'>
          <CompanyImageActions />
        </Box>
      </Grid>

      {/* Right Column: Address and future sections */}
      <Grid item xs={12} md={8} padding={3} >
        <Box className='companyDetailsContent_second_grid_box'>
          <CompanyAddress />
        </Box>
      </Grid>
      <Grid item xs={12} md={12} padding={3} >
        <CompanyContactDetails />
      </Grid>

    </Grid>
  );
}

export default CompanyDetailsContent;